import Model  from '@/utils/v01/ActiveModel';

export default class Dapil extends Model { 
    static backend = '/survey/dapil/';   

    static entity = 'dapil';    
    
    static fields () {
        return {
            id: this.attr(null),
            name: this.attr(''),
            node_id: this.attr(null),
            node_ids: this.attr([]),
            created_at: this.attr(null),
            created_by: this.attr(null),
            updated_at: this.attr(null),
            updated_by: this.attr(null),
        }
    }
    
    static nodes(params={}){
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }
}

